import { useState } from "react";
import { toast } from "sonner";
import { FlaskConical, ScrollText } from "lucide-react";
import { api } from "@/lib/api";
import { Btn, Card } from "@/components/PortalPage";

export const TermsList = ({ terms }) => (
  <ul className="list-disc space-y-1.5 pl-5 text-sm text-[#ccc]" data-testid="royalty-terms-list">
    {terms.map((t, i) => <li key={i}>{t}</li>)}
  </ul>
);

export const TermsCard = ({ st, onAccepted, title = "HOW ROYALTY IS COLLECTED" }) => {
  const [agree, setAgree] = useState(false);
  const [busy, setBusy] = useState(false);
  const blocked = st.support_session && !st.practice;
  const accept = async () => {
    setBusy(true);
    try { await api("/billing/terms/accept", { method: "POST" }); toast.success("Thanks. Royalty terms accepted."); onAccepted(); } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  return (
    <Card className="space-y-3 border-[#FFB800]/50" data-testid="royalty-terms-card">
      <p className="flex items-center gap-2 text-xs font-bold tracking-[2px] text-[#FFB800]"><ScrollText size={14} />{title}</p>
      <TermsList terms={st.terms || []} />
      {blocked
        ? <p className="text-xs text-[#FFB800]" data-testid="terms-support-note">The franchise owner needs to accept these terms from their own login.</p>
        : <>
            <label className="flex items-start gap-2 text-sm"><input type="checkbox" className="mt-1" checked={agree} onChange={(e) => setAgree(e.target.checked)} data-testid="terms-agree-checkbox" />I've read and agree to how royalty is collected, and to the fees above under my Franchise Agreement.</label>
            <Btn onClick={accept} busy={busy} disabled={!agree} data-testid="terms-accept-btn">I AGREE</Btn>
          </>}
    </Card>
  );
};

export const PracticeBanner = ({ st }) => st?.practice ? (
  <div className="flex items-center gap-2 rounded-xl border border-[#FFB800]/60 bg-[rgba(255,184,0,0.08)] p-3 text-sm text-[#FFB800]" data-testid="practice-banner">
    <FlaskConical size={16} />PRACTICE ACCOUNT. No real money moves: bank, card payments and drafts are simulated, and emails go to you.
  </div>
) : null;
